
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import store from '../../vuex/store'
import { go } from '../../libs/router'
import wx from 'weixin-js-sdk'
export default {
components: {
XButton,
Group,
Cell,
Alert
},
data () {
return {
imgSize: 1,
invoiceId: '',
warnMsgShow: false,
warnMsg: '',
imgList: [],
imgUrl: '',
hrefStr: '',
adId: '',
showDown: false,
invoiceKind: ''
}
},
created () {






store.commit( 'UPDATE_SHOW_FOOTER', false )
store.commit( 'UPDATE_TITLE', '票通云' )
var _this = this
_this.invoiceId = _this.$route.params.invoiceId
_this.$ajax.post( _this.ajaxFactory.get( 'invoiceInfo2' ), {}, {
params: {
id: _this.invoiceId
}
} ).then( function ( response ) {
var result = response.data
if ( result.code === '500' ) {
_this.warnMsgShow = true
_this.warnMsg = result.msg
} else {
if ( !result.imageSize || result.imageSize === 0 ) {
_this.warnMsgShow = true
_this.warnMsg = '该发票没有图片展示'
} else {
_this.invoiceKind = result.invoiceKind;
let imgHtml = ``
for ( var i = 0; i < result.imageSize; i++ ) {
const url = _this.host + _this.ajaxFactory.get( 'invoiceInfoImg2' ) + '?id=' + _this.invoiceId + '&index=' + i + '&qrCode=' + result.qrCode
imgHtml += `<img  src="${url}" onclick="(function() { wx.previewImage({ current: url, urls: _this.imgList }) })()" style="width:100%"> `
}
document.getElementById( 'fp_tu' ).innerHTML = imgHtml
const imgs = [...document.getElementById( 'fp_tu' ).getElementsByTagName( 'img' )]
imgs.forEach( fe => {
fe.onclick = ( e ) => {
wx.previewImage( {
current: e.target.src,
urls: [e.target.src]
} )
}
} )

}
}
store.commit( 'UPDATE_SHOW_FOOTER', false )
store.commit( 'UPDATE_TITLE', '票通云' )
window.document.getElementById( 'appTabbar' ).style.display = 'none'
} ).catch( function ( response ) {
console.log( response )
} )

































this.getAdPromotion()
},
methods: {
downApply () {
if ( this.invoiceKind > 80 ) {
this.showDown = true
} else {
window.location.href = this.ajaxFactory.get( 'downLoadLayoutFille' ) + '?fileType=PDF&id=' + this.invoiceId
}
},

downHandle ( fileType ) {
window.location.href = this.ajaxFactory.get( 'downLoadLayoutFille' ) + '?fileType=' + fileType + '&id=' + this.invoiceId
this.showDown = false;
},

getAdPromotion () {
var _this = this;
_this.$ajax.post( _this.ajaxFactory.get( 'getAdPromotion' ), {}, {
params: { adPosition: '6' }
} ).then( ( { data } ) => {
if ( data.code == 200 ) {
_this.hrefStr = data.data.href;
_this.imgUrl = data.data.imgUrl;
_this.adId = data.data.id;

let imgHtml = `<a href="${_this.hrefStr}" onclick="adPromotioClick()"> <img src="${_this.imgUrl}"> </a>`
document.getElementById( 'fp_ad' ).innerHTML = imgHtml

window.adPromotioClick = this.adPromotioClick;
}
} )
},

adPromotioClick () {
var _this = this;
_this.$ajax.post( _this.ajaxFactory.get( 'countAdHits' ), {}, {
params: {
id: this.adId
}
} ).then( ( res ) => { } );
},
onClick ( link ) {

window.location.href = '/?#/mail/' + this.invoiceId

},
showImage ( url ) {
var _this = this
wx.previewImage( {
current: url, // 当前显示图片的http链接
urls: _this.imgList 
} )
}
},
computed: {
isAndroid: function () {
var u = navigator.userAgent
return u.indexOf( 'Android' ) > -1 || u.indexOf( 'Adr' ) > -1
}
}
}



// WEBPACK FOOTER //
// ./src/components/fpj/fpjdetail2.vue